import { ApiContract, HttpMethods } from '@tc/http';
import { Api } from '../../configuration/Api';
import { Filter } from '../../../features/search/filters/models/filter.model';

/**
 * Contract for retrieving filter aggregations.
 */
@ApiContract({ endpoint: Api.filters, httpMethod: HttpMethods.post })
export class ApiGetFilters {
  constructor(readonly searchTerm: string, readonly filters: Filter[]) {}
}
